import { Card, CardContent, CardHeader, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Typography } from "@mui/material";
import { JENIS_BAYAR, JENIS_BERKAS, VERIFIED_BERKAS_FIELD } from "../../helper/Constant";
import { CheckBox, CheckBoxOutlineBlankOutlined } from "@mui/icons-material";
import LoadingSkeleton from "../general/LoadingSkeleton";

function DetailKelengkapan({ dataBerkas, pembayarans }) {

    const verifyBerkas = (berkasField) => {
        let isVerified = false;
        if (JENIS_BERKAS[berkasField] === JENIS_BERKAS.bukti_biaya_pendaftaran || JENIS_BERKAS[berkasField] === JENIS_BERKAS.bukti_biaya_daftar_ulang) {
            const pembayaranTerkait = pembayarans?.find(p => {
                if (JENIS_BERKAS[berkasField] === JENIS_BERKAS.bukti_biaya_pendaftaran) {
                    return p.type === JENIS_BAYAR.PENDAFTARAN;
                } else if (JENIS_BERKAS[berkasField] === JENIS_BERKAS.bukti_biaya_daftar_ulang) {
                    return p.type === JENIS_BAYAR.DAFTAR_ULANG;
                }
            });
            isVerified = pembayaranTerkait?.isLunas ? true : false;
        } else {
            isVerified = dataBerkas[VERIFIED_BERKAS_FIELD[berkasField]] ? true : false;
        }
        return isVerified ? <CheckBox>Sudah</CheckBox> : <CheckBoxOutlineBlankOutlined>Belum</CheckBoxOutlineBlankOutlined>;
    }

    const RenderTable = () => {
        if (!dataBerkas) {
            return (<>
                <LoadingSkeleton size={8}></LoadingSkeleton>
            </>);
        }
        return (
            <TableContainer sx={{ mt: 3 }} component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <center>
                                    Jenis Berkas
                                </center>
                            </TableCell>
                            <TableCell>
                                <center>
                                    Status Upload
                                    <br></br>
                                    <small>Calon santri</small>
                                </center>
                            </TableCell>
                            <TableCell>
                                <center>
                                    Status Verifikasi
                                    <br></br>
                                    <small>Panitia</small>
                                </center>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            Object.entries(JENIS_BERKAS).map(([key, value]) => {
                                return (
                                    <TableRow key={key}>
                                        <TableCell component="th" scope="row" align="left">{value}</TableCell>
                                        <TableCell align="center">{dataBerkas[key] ? <CheckBox>Sudah</CheckBox> : <CheckBoxOutlineBlankOutlined>Belum</CheckBoxOutlineBlankOutlined>}</TableCell>
                                        <TableCell align="center">{verifyBerkas(key)}</TableCell>
                                    </TableRow>
                                );
                            })
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        );
    }
    return (
        <>
            <Card>
                <CardHeader title="Kelengkapan Berkas" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    Berikut adalah tabel status berkas yang telah diupload.
                    <br></br>
                    <br></br>
                    Jika terdapat berkas yang harus di upload ulang karena suatu hal, silahkan upload kembali melalui form upload berkas di atas.
                    <br></br>
                    <br></br>
                    <span style={{ fontStyle: "italic", fontSize: "0.875rem", color: "#6c757d" }}><span style={{ fontWeight: "bold", color: "red" }}>Catatan:</span> Berkas <b>Bukti Pembayaran Daftar Ulang</b> dilakukan setelah pengumuman hasil seleksi diterima.</span>
                    {RenderTable()}
                </CardContent>
            </Card>

        </>
    )
}

export default DetailKelengkapan;